import { render, staticRenderFns } from "./ControleSaldosView.vue?vue&type=template&id=9cb3e7da&scoped=true"
import script from "./ControleSaldosView.vue?vue&type=script&lang=js"
export * from "./ControleSaldosView.vue?vue&type=script&lang=js"
import style0 from "./ControleSaldosView.vue?vue&type=style&index=0&id=9cb3e7da&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb3e7da",
  null
  
)

export default component.exports